module.exports = __webpack_public_path__ + "img/UI_RMYX_biaoqian_02_1_fcd13a31f.png";